import React from 'react'
import { Billboard, IBillboardProps } from '../Billboard/Billboard'
import { TextBlockList, ITextBlockListItemProps } from '../TextBlockList/TextBlockList'
import { ICMSTextV2Props, TextV2 as Text } from '../Text/TextV2'
import { IBillboardImageProps, MobileImageLocation, BillboardImage } from './BillboardImage'
import { IIconLinkProps, IconLinkList } from './IconLinkList'
import { IListItemsProps, ListItems } from '../BillboardWithPosterCard/PosterCard'

export interface IBillboardWithImageProps extends IBillboardProps {
  billboardImage: IBillboardImageProps
  headingList?: ITextBlockListItemProps[]
  itemList?: IListItemsProps
  headingDisclaimer?: ICMSTextV2Props
  iconLinkList?: IIconLinkProps[]
  dataTestId?: string
}

export const BillboardWithImage = ({
  billboardImage,
  headingList,
  headingDisclaimer,
  itemList,
  iconLinkList,
  sx = {},
  ...billboardProps
}: IBillboardWithImageProps) => {
  const isCopyRight = billboardProps.copyLocation === 'right'
  let mobileBillboardDirection = isCopyRight ? 'column-reverse' : 'column'

  if (billboardImage.mobileImageLocation) {
    mobileBillboardDirection =
      billboardImage.mobileImageLocation === MobileImageLocation.TOP ? 'column-reverse' : 'column'
  }

  const mobileMargin =
    mobileBillboardDirection === 'column-reverse'
      ? { marginBottom: ['32px', '32px', 0] }
      : { marginTop: ['32px', '32px', 0] }

  return (
    <Billboard
      {...billboardProps}
      sx={{
        ...(billboardImage.isOverlapping ? { overflow: 'hidden' } : {}),
        alignItems: 'center',
        width: '100%',
        flexDirection: [mobileBillboardDirection, mobileBillboardDirection, `row${isCopyRight ? '-reverse' : ''}`],
        ...sx,
      }}
      headingChildren={
        <>
          {headingList ? (
            <>
              <TextBlockList list={headingList} sx={{ marginBottom: '20px', marginTop: '20px' }} />
              {headingDisclaimer ? (
                <Text
                  tag={headingDisclaimer.tag}
                  textFontStyle={headingDisclaimer.textFontStyle}
                  textFontColor={headingDisclaimer.textFontColor}
                >
                  {headingDisclaimer.text}
                </Text>
              ) : null}
            </>
          ) : null}
          {itemList ? <ListItems items={itemList.items} sx={itemList.sx} /> : null}
          {iconLinkList ? <IconLinkList items={iconLinkList} /> : null}
        </>
      }
    >
      <BillboardImage {...billboardImage} sx={{ ...mobileMargin, ...billboardImage.sx }} />
    </Billboard>
  )
}
